let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gkfGT")).then(() => parcelRequire('2HnQV'));